import { GroupsOutlined, PersonOutline, SchoolOutlined } from "@mui/icons-material";
import { Box, Card, CardActionArea, CardContent, Grid, Stack, Typography } from "@mui/material";

const tStudent = "Student";
const tStudentHint = "Search students to sign in or sign out.";
const tFaculty = "Faculty";
const tFacultyHint = "Sign in as a staff member.";
const tVisitor = "Visitor";
const tVisitorHint = "Coming soon.";

export interface VisitorManagementActionCardsProps {
  isKiosk: boolean;
  onFacultyCardClick: () => void;
  onStudentCardClick: () => void;
}

export function VisitorManagementActionCards({
  isKiosk,
  onFacultyCardClick,
  onStudentCardClick,
}: VisitorManagementActionCardsProps) {
  return (
    <Grid
      container
      spacing={isKiosk ? 3 : 2}
      sx={
        isKiosk
          ? {
              alignContent: "stretch",
              flex: "1 1 auto",
              minHeight: 0,
            }
          : { mb: 4 }
      }
    >
      <Grid size={isKiosk ? 12 : { md: 4, xs: 12 }}>
        <Card
          elevation={2}
          sx={isKiosk ? { display: "flex", flex: "1 1 auto", flexDirection: "column", minHeight: 0 } : undefined}
          variant="outlined"
        >
          <CardActionArea
            onClick={onStudentCardClick}
            sx={{
              alignItems: "stretch",
              flex: isKiosk ? 1 : undefined,
              minHeight: isKiosk ? { md: 200, xs: 160 } : 112,
              px: isKiosk ? 2 : undefined,
              py: isKiosk ? 3 : undefined,
            }}
          >
            <CardContent sx={{ width: "100%" }}>
              <Stack alignItems={isKiosk ? "center" : "flex-start"} direction="row" gap={isKiosk ? 3 : 2}>
                <SchoolOutlined color="primary" sx={{ fontSize: isKiosk ? { md: 96, xs: 72 } : 40 }} />
                <Box sx={{ textAlign: isKiosk ? "left" : undefined }}>
                  <Typography component="h2" variant={isKiosk ? "h4" : "h5"}>
                    {tStudent}
                  </Typography>
                  <Typography color="text.secondary" component="p" variant={isKiosk ? "h6" : "body2"}>
                    {tStudentHint}
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
      <Grid size={isKiosk ? 12 : { md: 4, xs: 12 }}>
        <Card
          elevation={2}
          sx={isKiosk ? { display: "flex", flex: "1 1 auto", flexDirection: "column", minHeight: 0 } : undefined}
          variant="outlined"
        >
          <CardActionArea
            onClick={onFacultyCardClick}
            sx={{
              alignItems: "stretch",
              flex: isKiosk ? 1 : undefined,
              minHeight: isKiosk ? { md: 200, xs: 160 } : 112,
              px: isKiosk ? 2 : undefined,
              py: isKiosk ? 3 : undefined,
            }}
          >
            <CardContent sx={{ width: "100%" }}>
              <Stack alignItems={isKiosk ? "center" : "flex-start"} direction="row" gap={isKiosk ? 3 : 2}>
                <GroupsOutlined color="primary" sx={{ fontSize: isKiosk ? { md: 96, xs: 72 } : 40 }} />
                <Box sx={{ textAlign: isKiosk ? "left" : undefined }}>
                  <Typography component="h2" variant={isKiosk ? "h4" : "h5"}>
                    {tFaculty}
                  </Typography>
                  <Typography color="text.secondary" component="p" variant={isKiosk ? "h6" : "body2"}>
                    {tFacultyHint}
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
      <Grid size={isKiosk ? 12 : { md: 4, xs: 12 }}>
        <Card
          elevation={0}
          sx={{
            opacity: 0.72,
            ...(isKiosk ? { display: "flex", flex: "1 1 auto", flexDirection: "column", minHeight: 0 } : {}),
          }}
          variant="outlined"
        >
          <CardActionArea
            disabled
            sx={{
              alignItems: "stretch",
              cursor: "not-allowed",
              flex: isKiosk ? 1 : undefined,
              minHeight: isKiosk ? { md: 200, xs: 160 } : 112,
              px: isKiosk ? 2 : undefined,
              py: isKiosk ? 3 : undefined,
            }}
          >
            <CardContent sx={{ width: "100%" }}>
              <Stack alignItems={isKiosk ? "center" : "flex-start"} direction="row" gap={isKiosk ? 3 : 2}>
                <PersonOutline color="disabled" sx={{ fontSize: isKiosk ? { md: 96, xs: 72 } : 40 }} />
                <Box sx={{ textAlign: isKiosk ? "left" : undefined }}>
                  <Typography component="h2" variant={isKiosk ? "h4" : "h5"}>
                    {tVisitor}
                  </Typography>
                  <Typography color="text.secondary" component="p" variant={isKiosk ? "h6" : "body2"}>
                    {tVisitorHint}
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
    </Grid>
  );
}
